var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C3 4.90625 3.875 4 5 4H17C18.0938 4 19 4.90625 19 6V16C19 17.125 18.0938 18 17 18H5C3.875 18 3 17.125 3 16V6ZM9 8.25H17.5V6C17.5 5.75 17.25 5.5 17 5.5H9V8.25ZM7.5 5.5H5C4.71875 5.5 4.5 5.75 4.5 6V8.25H7.5V5.5ZM4.5 9.75V12.25H7.5V9.75H4.5ZM4.5 13.75V16C4.5 16.2812 4.71875 16.5 5 16.5H7.5V13.75H4.5ZM9 16.5H17C17.25 16.5 17.5 16.2812 17.5 16V13.75H9V16.5ZM17.5 12.25V9.75H9V12.25H17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.1677a1e4a6b3e709f187a52b499f534f.svg";
export { ForwardRef as ReactComponent };